import 'leaflet/dist/leaflet.css'

import { BrowserRouter, RouterProvider } from 'react-router-dom'
import { MainRoutes, router } from './routes/routes'
import './styles/index.scss'
import './App.css'

function App() {
	const favicon: any = document.querySelector("link[rel~='icon']")
	if (favicon) favicon.href = 'favicon.ico?v=2'

	return (
		// <BrowserRouter>	
			
				<RouterProvider router={router}/>
			
		// </BrowserRouter>
	)
}

export default App
